function _onVatValidate (country, vatNo, callback) {
  if (vatNo === undefined && !vatNo) {
    callback(true) // eslint-disable-line
  }
  /* if (vatNo !== undefined && vatNo) {
    const params = { query: { country: country, vatNumber: vatNo } };
    app.service('/api/page/vatvalidate').find(params).then((res) => {
      if (res && res.bValid) {
        callback(true);
      } else {
        callback(false);
      }
    }).catch((err) => {
      callback(false);
    });
  } else {
    callback(true);
  } */
}

const ContactUtil = {}
ContactUtil.onVatValidate = _onVatValidate

export default ContactUtil
